import React from "react";

const Table = (props: any) => {
  return (
    <table className={"table" + (props.className ? " " + props.className : "")}>
      {props.children}
    </table>
  );
};

export default Table;
